export default window.MicroModal;